import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import '../css/consulting2105.css';
import Bg from '../images/Event/consulting2105/bg.png';

class EventConsulting extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }

  componentDidMount() {
    window.pageVisit('consulting');
  }

  render() {
    return (
      <Fragment>
        <div id="skipNavi">
          <h1 className="blind">TOZ StudyCenter 스킵네비게이션</h1>
          <ul>
            <li><a href="#contents" className="skipLink">본문바로가기</a></li>
            <li><a href="#topmenu" className="skipLink">주메뉴바로가기</a></li>
          </ul>
        </div>
        <div id="doc" className="isPage">	
          <div id="pg-code" className="doc-pg">
            <div id="container-wrap"  className="div-cont consulting" style={{background: '#fff'}}>
              <div id="contents" style={{background: '#fff'}}>
                <img src={Bg} style={{width: '100%'}} />
                <a href="https://bit.ly/3hus523" target="_blank" className="Btn" onClick={() => window.pageComplete('consulting')}></a>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default EventConsulting;
